import {
  ViewEncapsulation, Injectable, Component,
  OnInit, Input, OnChanges, SimpleChange, Output, EventEmitter
} from "@angular/core";

@Component({
  selector: "app-dse7200",
  templateUrl: "./dse7200.component.html",
  styleUrls: ["./dse7200.component.css"]
})
export class Dse7200Component implements OnInit, OnChanges {
  @Input() Item: any = undefined;
  constructor() { }
  // private i = 0;
  // private test = {
  //   UUID: "4e0e6139-984d-451d-b9fa-2aaa2717de5a",
  //   enable: true,
  //   version: 1,
  //   index: 0,
  //   modelSerial: "DSE-7200",
  //   name: "深海發電機控制系統DSE-7200",
  //   serialNO: "72000000200070",
  //   Runningmethod: "auto",
  //   IsConnected: true,
  //   LEDStatus: {
  //     FuelRelay: true,
  //     StartRelay: true,
  //     DigitalOutE: true,
  //     DigitalOutF: true,
  //     DigitalOutG: true,
  //     DigitalOutH: true,
  //     DigitalOutD: true,
  //     DigitalOutC: true,
  //     STOP: true,
  //     MANUAL: true,
  //     TEST: true,
  //     AUTO: true,
  //     MAINS: true,
  //     MAINSBREAKER: true,
  //     GENBREAKER: true,
  //     GEN: true,
  //     USER1: true,
  //     USER2: false,
  //     USER3: false,
  //     USER4: false,
  //   },
  //   DigitalInput: {
  //     RawA: true,
  //     ProcessedA: false,
  //     RawB: true,
  //     ProcessedB: true,
  //     RawC: false,
  //     ProcessedC: false,
  //     RawD: true,
  //     ProcessedD: true,
  //     RawE: true,
  //     ProcessedE: true,
  //     RawF: false,
  //     ProcessedF: true,
  //     RawG: true,
  //     ProcessedG: false,
  //   },
  //   Mains: {
  //     frequency: this.i++,
  //     L1Nvoltage: this.i++,
  //     L2Nvoltage: this.i++,
  //     L3Nvoltage: this.i++,
  //     L1L2voltage: this.i++,
  //     L2L3voltage: this.i++,
  //     L3L1voltage: this.i++,
  //     voltagephaselaglead: this.i++,
  //     phaserotation: this.i++,
  //     currentlaglead: this.i++,
  //     L1current: this.i++,
  //     L2current: this.i++,
  //     L3current: this.i++,
  //     earthcurrent: this.i++,
  //     L1watts: this.i++,
  //     L2watts: this.i++,
  //     L3watts: this.i++,
  //     totalwatts: this.i++,
  //     L1VA: this.i++,
  //     L2VA: this.i++,
  //     L3VA: this.i++,
  //     totalVA: this.i++,
  //     L1Var: this.i++,
  //     L2Var: this.i++,
  //     L3Var: this.i++,
  //     totalVar: this.i++,
  //     powerfactorL1: this.i++,
  //     powerfactorL2: this.i++,
  //     powerfactorL3: this.i++,
  //     averagepowerfactor: this.i++,
  //   },
  //   Generator: {
  //     frequency: this.i++,
  //     L1Nvoltage: this.i++,
  //     L2Nvoltage: this.i++,
  //     L3Nvoltage: this.i++,
  //     L1L2voltage: this.i++,
  //     L2L3voltage: this.i++,
  //     L3L1voltage: this.i++,
  //     L1current: this.i++,
  //     L2current: this.i++,
  //     L3current: this.i++,
  //     earthcurrent: this.i++,
  //     L1watts: this.i++,
  //     L2watts: this.i++,
  //     L3watts: this.i++,
  //     currentlaglead: this.i++,
  //     totalwatts: this.i++,
  //     L1VA: this.i++,
  //     L2VA: this.i++,
  //     L3VA: this.i++,
  //     totalVA: this.i++,
  //     L1Var: this.i++,
  //     L2Var: this.i++,
  //     L3Var: this.i++,
  //     totalVar: this.i++,
  //     powerfactorL1: this.i++,
  //     powerfactorL2: this.i++,
  //     powerfactorL3: this.i++,
  //     averagepowerfactor: this.i++,
  //     percentageoffullpower: this.i++,
  //     percentageoffullVar: this.i++,
  //     positiveKWhours: this.i++,
  //     negativeKWhours: this.i++,
  //     KVAhours: this.i++,
  //     KVArhours: this.i++,
  //   },
  //   Engine: {
  //     OilPressure: this.i++,
  //     CoolantTemperature: this.i++,
  //     OilTemperature: this.i++,
  //     FuleLevel: this.i++,
  //     InternalFlexibleSenderAnalogueInputType: 0,
  //     InternalFlexibleSenderAnalogueInputReading: 0,
  //     ChargeAlternatorVoltage: this.i++,
  //     EngineBatteryVoltage: this.i++,
  //     EngineSpeed: this.i++,
  //     EngineRunTime: this.i++,
  //     NumberOfStarts: this.i++,
  //   },
  //   Alarm: {
  //     NumberOfNamedAlarms: this.i++,
  //     EmergencyStop: 0x1,
  //     LowOilPressure: 0x0,
  //     HighCoolantTemperature: 0x3,
  //     LowCoolantTemperature: 0x2,
  //     UnderSpeed: 0x1,
  //     OverSpeed: 0x2,
  //     GeneratorUnderFrequency: 0x1,
  //     GeneratorOverFrequency: 0x1,
  //     GeneratorLowVoltage: 0x2,
  //     GeneratorHighVoltage: 0x2,
  //     BatteryLowVoltage: 0x1,
  //     BatteryHighVoltage: 0x3,
  //     ChargeAlternatorFailure: 0x3,
  //     FailToStart: 0x1,
  //     FailToStop: 0x3,
  //     GeneratorFailToClose: 0x4,
  //     MainsFailToClose: 0x1,
  //     OilPressureSenderFault: 0x1,
  //     LossOfMagneticPickUp: 0x4,
  //     MagneticPickUpOpenCircuit: 0x4,
  //     GeneratorHighCurrent: 0x4,
  //     NoneA: 0x1,
  //     LowFuelLevel: 0x0,
  //     CANECUWarning: 0x0,
  //     CANECUShutdown: 0x2,
  //     CANECUDataFail: 0x3,
  //     LowOillevelSwitch: 0x1,
  //     HighTemperatureSwitch: 0x2,
  //     LowFuelLevelSwitch: 0x2,
  //     ExpansionUnitWatchdogAlarm: 0x1,
  //     kWOverloadAlarm: 0x1,
  //     NegativePhaseSequenceCurrentAlarm: 0x2,
  //     EarthFaultTripAlarm: 0x3,
  //     GeneratorPhaseRotationAlarm: 0x1,
  //     AutoVoltageSenseFail: 0x3,
  //     MaintenanceAlarm: 0x0,
  //     LoadingFrequencyAlarm: 0x0,
  //     LoadingVoltageAlarm: 0x1,
  //     NoneB: 0x3,
  //     NoneC: 0x3,
  //     NoneD: 0x3,
  //     NoneE: 0x2,
  //     GeneratorShortCircuit: 0x1,
  //     MainsHighCurrent: 0x1,
  //     MainsEarthFault: 0x1,
  //     MainsShortCircuit: 0x1,
  //     ECUProtect: 0x2,
  //     NoneF: 0x0,

  //     Message: [],
  //   },
  // };


  ngOnInit() {
    if (this.Item !== undefined && this.Item.status !== undefined) {

    }
    // this.Item = this.test;
  }
  async ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
    if (this.Item !== undefined && this.Item.status !== undefined) {

    }
    // this.Item = this.test;
  }
  toInternalFlexibleSenderType(s: number): string {
    switch (s) {
      case 0:
        return `Unused`;
      case 1:
        return `Pressure`;
      case 2:
        return `Temperature`;
      case 3:
        return `Level`;
      default:
        return s.toString();
    }
  }
  ALCSS(s: number): string {
    switch (s) {
      case 0b0000:
        return ``;
      case 0b0001:
        return `bg-success`;
      case 0b0010:
        return `bg-warning`;
      case 0b0011:
        return `bg-danger`;
      case 0b0100:
        return `bg-danger`;
      case 0b1111:
        return ``;
      default:
        return `bg-info`;
    }
  }
  AL(s: number): string {
    switch (s) {
      case 0b0000:
        return `無資訊`;
      case 0b0001:
        return `正常`;
      case 0b0010:
        return `警報`;
      case 0b0011:
        return `停機`;
      case 0b0100:
        return `電氣跳閘`;
      case 0b1111:
        return `未實作`;
      default:
        return s.toString();
    }
  }
}



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/Component/ESS-BA20GA30IGW/dse7200/dse7200.component.ts